module.exports = __webpack_public_path__ + "img/airplane-6.0858796b.jpg";